import amex from './amex.svg';
import cabal from './cabal.svg';
import diners from './diners.svg';
import maestro from './maestro.svg';
import naranja from './naranja.svg';
import mastercard from './mastercard.svg';
import miCarrefour from './mi_carrefour.svg';
import visa from './visa.svg';

const BY_KEY: Record<string, string> = {
  visa,
  mastercard,
  amex,
  cabal,
  maestro,
  diners,
  naranja,
  mi_carrefour: miCarrefour,
  // Clave de tema/banco del backend (V10__seed_card_theme.sql); el logo es el de Carrefour.
  cuenta_digital_carrefour: miCarrefour,
};

const BY_LABEL: Record<string, string> = {
  ...BY_KEY,
  master: mastercard,
  'american express': amex,
};

/** URL del SVG monocromo, o null si esa red no tiene archivo. */
export function networkIconUrl(icon: string | undefined, networkLabel: string): string | null {
  const key = icon?.trim().toLowerCase();
  if (key && BY_KEY[key]) return BY_KEY[key];
  const label = networkLabel.trim().toLowerCase();
  return BY_LABEL[label] ?? null;
}
